<template>
  <div class="score-legend">
    <div class="score">
      <div class="score-radius achieved"></div>
      <span class="f-ui-3">Achieved</span>
    </div>
    <div class="score">
      <div class="score-radius in-force"></div>
      <span class="f-ui-3">In force</span>
    </div>
    <div class="score">
      <div class="score-radius announced"></div>
      <span class="f-ui-3">Announced</span>
    </div>
    <!--
    <div class="score">
      <div class="score-radius EU"></div>
      <span class="f-ui-3">Covered by EU policy</span>
    </div>
    -->
    <!-- <div class="score">
      <div class="score-radius ended"></div>
      <span class="f-ui-3">Ended</span>
    </div> -->
  </div>
</template>

<script>
export default {};
</script>

<style>
.score-legend {
  display: flex;
  height: 26px;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 24px;
}
.score-legend .score {
  flex: 0 1 auto !important;
}
</style>